import React, { Component } from 'react'
import moment from 'moment'
import { SingleDatePicker } from 'react-dates'
import { QueryService } from 'services/queries'
import ErrorType from 'services/ErrorType'
import config from 'services/config'
import MoneyValue from 'components/MoneyValue'

import 'react-dates/lib/css/_datepicker.css'

//import jQuery from 'services/jQueryDatatablesBootstrap'
import { BootstrapTable, TableHeaderColumn, ExportCSVButton } from 'react-bootstrap-table';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import Spinner from 'react-spinkit'

import Select from 'react-select'
import 'react-select/dist/react-select.css';


let _moneyFormat = value => (<MoneyValue value={value}/>)
let _dateFormat = date => moment(date).format('M/D/YYYY')
let _humanize = s => {
  return s ? s.replace(/_/g, ' ').trim().replace(/([^\s])([A-Z])/g, '$1 $2').replace(/\b[A-Z][a-z]+\b/g, function (x) {
    return x.toLowerCase();
  }).replace(/^[a-z]/g, function (x) {
    return x.toUpperCase();
  }) : null;
};
let _humanizeJournal = s => (_humanize(s) || 'Total outstanding')
let _booleanFormat = x => x ? '✓' : ''

class AccountSummaryAge extends Component {

  render() {

    return (
      <div className="card">
        <h3 className="card-title">
          Summary as of {this.props.date.format('MMMM D, YYYY')}
          <div className="pull-right"><MoneyValue value={this.props.data[0].balance}/></div>
        </h3>
          <table className="table table-condensed table-hover">
            <thead>
              <tr>
                <th className="col-md-2 text-left"></th>
                <th className="col-md-1 text-right border-right">Balance</th>
                <th className="col-md-1 text-right">Amount due</th>
                <th className="col-md-1 text-right">0-15 days</th>
                <th className="col-md-1 text-right">16-30 days</th>
                <th className="col-md-1 text-right">31-60 days</th>
                <th className="col-md-1 text-right">61-120 days</th>
                <th className="col-md-1 text-right">120+ days</th>
              </tr>
            </thead>
            <tbody>
              {this.props.data.map(row => (row.balance != 0) && (
                <tr className={ (row.journal === this.props.journal) ? 'warning' :'' }
                    onClick={this.props.onChange}
                    id={row.journal}
                    style={{cursor: 'pointer'}} >
                  <td className="text-left">{_humanize(row.journal_display) || 'Total outstanding'}</td>
                  <td className="text-right border-right"><MoneyValue value={row.balance}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_due}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_0_15}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_16_30}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_31_60}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_61_120}/></td>
                  <td className="text-right"><MoneyValue value={row.balance_120_plus}/></td>
                </tr>
              ))}
            </tbody>
          </table>
      </div>
    )

  }

}


class AgingTable extends Component {

  constructor(props) {
    super(props)
    this.onRowClick = this.onRowClick.bind(this)
  }

  onRowClick(row) {
    this.props.history.push({
      pathname: '/dashboard/accounts',
      state: { account: row.contract, date: row.report_date }
    })
  }

  render() {

    return (
      <div className="card">
        <div className="card-body">
          { (this.props.loading) && <Spinner name='circle' /> }
          <BootstrapTable
            data={this.props.data}
            striped
            hover
            pagination
            exportCSV
            csvFileName={`balance_summary_${this.props.journal || 'net'}_${this.props.date.format('YYYY_MM_DD')}.csv`}
            search
            trStyle={ () => ({cursor: 'pointer'})}
            options={{
              sizePerPage: 50,
              paginationShowsTotal: true,
              paginationPosition: 'top',
              hideSizePerPage: true,
              defaultSortName: 'contract',
              defaultSortOrder: 'asc',
              exportCSVBtn: () => <ExportCSVButton className='btn-blue'/>,
              onRowClick: this.onRowClick
            }}>
            <TableHeaderColumn dataField="account" dataFormat={_humanize} dataSort>Account</TableHeaderColumn>
            <TableHeaderColumn dataField="contract" dataFormat={_humanize} dataSort isKey>Contract</TableHeaderColumn>
            <TableHeaderColumn dataField="journal" dataFormat={_humanizeJournal} csvFormat={_humanizeJournal}>Balance type</TableHeaderColumn>
            <TableHeaderColumn dataField="balance" dataSort dataFormat={_moneyFormat} dataAlign="right">Balance</TableHeaderColumn>
            <TableHeaderColumn dataField="balance_due" dataSort dataFormat={_moneyFormat} dataAlign="right"  width="8em">Amount due</TableHeaderColumn>
            <TableHeaderColumn dataField="days_past_due" dataSort dataAlign="right"  width="8em">Days past</TableHeaderColumn>
            <TableHeaderColumn dataField="balance_0_15" dataSort dataFormat={_moneyFormat} dataAlign="right"  width="8em">0-15 days</TableHeaderColumn>
            <TableHeaderColumn dataField="balance_16_30" dataSort dataFormat={_moneyFormat} dataAlign="right"  width="8em">16-30 days</TableHeaderColumn>
            <TableHeaderColumn dataField="balance_31_60" dataSort dataFormat={_moneyFormat} dataAlign="right"  width="8em">31-60 days</TableHeaderColumn>
            <TableHeaderColumn dataField="balance_61_120" dataSort dataFormat={_moneyFormat} dataAlign="right"  width="8em">61-120 days</TableHeaderColumn>
            <TableHeaderColumn dataField="balance_120_plus" dataSort dataFormat={_moneyFormat} dataAlign="right"  width="8em">120+ days</TableHeaderColumn>
            {/*<TableHeaderColumn dataField="active" dataFormat={_booleanFormat} dataSort width="5em" dataAlign="center">Active?</TableHeaderColumn>*/}
          </BootstrapTable>
        </div>
      </div>
    )
  }
}


class Aging extends Component {

  constructor(props) {

    super(props)
    this.state = {
      balanceDate: moment(), //this.props.maxDate,  //moment(this.props.maxDate).add(1, 'days').add(-1, 'months').endOf('month'),
      balanceDateFocus: false,
      balances: [],
      summary: [],
      journal: null,
      currentPage: 1,
      pageSize: 100,
      recordCount: 0,
      loading: false,
      contractStatus: ''
    }

    this.onBalanceDateChange = this.onBalanceDateChange.bind(this)
    this.onBalanceDateFocusChange = this.onBalanceDateFocusChange.bind(this)
    this.isOutsideBalanceDateRange = this.isOutsideBalanceDateRange.bind(this)
    this.onPaginationChanged = this.onPaginationChanged.bind(this)
    this.onJournalChange = this.onJournalChange.bind(this)
    this.onContractStatusChange = this.onContractStatusChange.bind(this)
    this.fetchBalances = this.fetchBalances.bind(this)
    this.fetchAgingSummary = this.fetchAgingSummary.bind(this)
    this.fetchAgingAccounts = this.fetchAgingAccounts.bind(this)
    this.fetchAgingAccountsFirst = this.fetchAgingAccountsFirst.bind(this)
    this.queryService = new QueryService(this.props.book)

  }

  componentWillMount() {
    this.fetchBalances(this.state.balanceDate, this.state.contractStatus)
  }


  onBalanceDateFocusChange(p) {
    this.setState({
      balanceDateFocus: p.focused
    })
  }

  onBalanceDateChange(date) {
//    if (!(moment(date).isSame(this.props.maxDate))) {
//      date = moment(date).endOf('month')
//      if (date.isAfter(this.props.maxDate)) date.add(-1, 'months').endOf('month')
//    }
    this.fetchBalances(date, this.state.contractStatus)
  }

  onJournalChange(journalEvent) {
    let journal = journalEvent.currentTarget.id || null 
    this.setState({
      journal: journal
    });
  }

  async onContractStatusChange(status) {
    this.fetchBalances(this.state.balanceDate, status.value)
  }


  async fetchAgingSummary(date, status) {
    try {
      let result = await this.queryService.getAgingSummary(date, status)
      this.setState({
        summary: result.summary
      })
    } catch (err) {
      if (err && err.type) {
        if (err.type === ErrorType.Authorization) {
          this.props.history.push(config.loginPage)
          return
        }
      }
      throw err
    }
  }

  async fetchAgingAccountsFirst(date, status) {
    try {
      let result = await this.queryService.getAgingAccountsFirst(date, status)
      this.setState({
        balances: result.balances,
        loading: true
      })
    } catch (err) {
      if (err && err.type) {
        if (err.type === ErrorType.Authorization) {
          this.props.history.push(config.loginPage)
          return
        }
      }
      throw err
    }
  }

  async fetchAgingAccounts(date, status) {
    try {
      let result = await this.queryService.getAgingAccounts(date, status)
      this.setState({
        balances: result.balances,
        loading: false
      })
    } catch (err) {
      if (err && err.type) {
        if (err.type === ErrorType.Authorization) {
          this.props.history.push(config.loginPage)
          return
        }
      }
      throw err
    }
  }

  async fetchBalances(date, status) {
    this.fetchAgingSummary(date, status)
    await this.fetchAgingAccountsFirst(date, status)
    this.fetchAgingAccounts(date, status)
    this.setState({
      balanceDate: date,
      contractStatus: status
    })
  }


  isOutsideBalanceDateRange(date) {
    return moment().add(7, 'days').isBefore(date)
  }

  onPaginationChanged(pagination) {

  }

  render() {
    return (
      <div className="content-wrapper">
        <div className="page-title">
          <div>
            <h1><i className="fa fa-bar-chart-o"></i> Balances</h1>
            <p>Outstanding balances by account</p>
          </div>
          <div className="form-inline">
            <label className="header-input">
              <span className="period">Status</span>
              <Select
                className="form-control" 
                name="Status"
                options={[
                  { value: '', label: 'All contracts' },
                  { value: 'ACTIVE', label: 'Active contracts only' },
                  { value: 'COMPLETED', label: 'Completed contracts only' },
                  { value: 'SUSPENDED', label: 'Suspended contracts only' },
                  { value: 'CANCELED', label: 'Canceled contracts only' },
                ]}
                value={this.state.contractStatus}
                clearable={false}
                searchable={false}
                onChange={this.onContractStatusChange}
              />
            </label>
            <label className="header-input">
              <span className="period">Date</span>
              <SingleDatePicker
                date={this.state.balanceDate}
                onDateChange={this.onBalanceDateChange}
                onFocusChange={this.onBalanceDateFocusChange}
                focused={this.state.balanceDateFocus}
                numberOfMonths={1}
                isOutsideRange={this.isOutsideBalanceDateRange} />
            </label>

            {/*<ul className="breadcrumb">
              <li><i className="fa fa-home fa-lg"></i></li>
              <li>Tables</li>
              <li className="active"><a href="#">Simple Tables</a></li>
            </ul>*/}
          </div>
        </div>
          <div className="row small">
          { (this.state.summary.length > 0) &&
            <div className="col-md-12">
              <AccountSummaryAge
                data={this.state.summary}
                date={this.state.balanceDate}
                journal={this.state.journal}
                onChange={this.onJournalChange}
              />
            </div>
          }
          { (this.state.balances.length > 0) &&
            <div className="col-md-12">
              <AgingTable
                data={this.state.balances.filter( row => row.journal == this.state.journal )}
                date={this.state.balanceDate}
                journal={this.state.journal}
                loading={this.state.loading}
                history={this.props.history}
              />
            </div>
          }
          </div>
      </div>
    )
  }
}

export default Aging

//                onDateChange={this.onBalanceDateChange}
//                onFocusChange={this.onBalanceDateFocusChange}
//                focused={this.state.balanceDateFocus}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Aging/index.js